module.exports = __webpack_public_path__ + "static/img/topic_ic.b3d247a2.png";